import { render, staticRenderFns } from "./SharedReviewConfirmStep.vue?vue&type=template&id=debee062&scoped=true"
import script from "./SharedReviewConfirmStep.vue?vue&type=script&lang=js"
export * from "./SharedReviewConfirmStep.vue?vue&type=script&lang=js"
import style0 from "./SharedReviewConfirmStep.vue?vue&type=style&index=0&id=debee062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debee062",
  null
  
)

export default component.exports